import { useMemo } from "react";

import { experiments, useExperiment } from "@/utils/experiment";

export function useCfind6099JiraGoogleOnlySocialProviders():
    | { google: string }
    | undefined {
    const experiment = useExperiment(
        experiments.cfind6099JiraRemoveSocialSignups
    );

    return useMemo(() => {
        if (experiment.type === "enrolled" && experiment.value === true) {
            return { google: "Google" };
        }

        return undefined;
    }, [experiment]);
}
